// extracted by mini-css-extract-plugin
module.exports = {"faqRegion":"FAQBlock_faqRegion__3EeEI","faqRegionTitle":"FAQBlock_faqRegionTitle__iknRK"};